import { faUser } from "@fortawesome/free-solid-svg-icons";
import React, { useContext } from "react";
import { UserContext } from "../../../common/user/UserContext";
import { ThemeContext } from "../../../common/theme/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Dropdown from "../../../common/dropdown/Dropdown";
import UserDropdown from "../../../common/userDropdown/UserDropdown";

function UserInfo() {
  const user = useContext(UserContext);
  const theme = useContext(ThemeContext);

  return (
    <div className="navbar-item">
      <Dropdown
        button={() => (
          <button
            className={`button has-background-${theme.navColor} has-text-${theme.navText} is-${theme.navText}`}
          >
            <span className="icon">
              <FontAwesomeIcon icon={faUser} />
            </span>
            <span className="is-uppercase">
              {user && user.firstName} {user && user.lastName}
            </span>
          </button>
        )}
      >
        <UserDropdown />
      </Dropdown>
    </div>
  );
}

export default UserInfo;
